import { Moment } from 'moment';
import { FileDocumentType } from '@nkr/enums/document-type';

export interface IWatrSupplementalUploadedDoc {
    key: string;
    fileName: string;
    fileTypeDescription: string;
    uploadedDateTime: string | null;
    sortMoment: Moment;
    docType: FileDocumentType;
}
